module.exports = __webpack_public_path__ + "static/media/INHALT.c9a8b2c8.jpg";